module.exports = __webpack_public_path__ + "static/media/money-received.2353e693.svg";